import { createMuiStyles } from '../../../../utils/mui';

export const registeredStatisticsStyles = createMuiStyles({
  triangle: {
    display: 'block',
    width: '100%',
    height: '15rem',
  },
  triangleBottom: {
    rotate: '180deg',
    position: 'absolute',
    bottom: 0,
    left: 0,
    transform: 'translateY(-100%)',
    zIndex: -1,
  },
  illustration: {
    height: '15rem',
    width: 'auto',
    display: 'block',
  },
  card: {
    p: 3,
    borderRadius: 2,
    bgcolor: 'common.white',
    height: 1,
  },
});
